module.exports = __webpack_public_path__ + "static/media/greenext.bbea5890.svg";